document.addEventListener('DOMContentLoaded', () => {
  const canvas = document.getElementById('tt-frames-canvas');
  const ctx = canvas.getContext('2d');

  const dpr = window.devicePixelRatio || 1;
  const rect = canvas.getBoundingClientRect();

  canvas.width = rect.width * dpr;
  canvas.height = rect.height * dpr;
  // ctx.scale(dpr, dpr);

  const imageWidth = 1920;
  const imageHeight = 1258;

  const ratio = imageWidth / imageHeight;

  const frames = window.liquidTTFrames;
  const framesCount = frames.length;

  const animState = {
    frame: 0,
  };

  const images = [];
  const preloadImages = () => {
    frames.forEach((frame) => {
      let src = frame;

      const img = new Image();
      img.src = src;
      images.push(img);
    });
  };
  preloadImages();

  const render = () => {
    const image = images[animState.frame];
    // const image = images[images.length - 1];

    ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, canvas.width, canvas.height);
  };

  function updateCanvasSize() {
    const canvasSize = getCanvasSize();
    canvas.width = canvasSize.width;
    canvas.height = canvasSize.height;

    document.querySelectorAll('.umbrella-frame__sizing').forEach((el) => {
      el.style.height = canvasSize.height + 'px';
      el.style.width = canvasSize.width + 'px';
    });

    render();
  }

  updateCanvasSize();

  function getCanvasSize() {
    const navbarHeight = 90;
    let [width, height] = [window.innerWidth, window.innerHeight - navbarHeight];
    let [scaledWidth, scaledHeight] = [height * ratio, width / ratio];

    if (scaledWidth > width) {
      width = scaledWidth;
    } else {
      height = scaledHeight;
    }

    return { width, height };
  }

  render();
  images[0].addEventListener('load', function () {
    render();
  });

  const tl = gsap.timeline();
  let dotPopupShown = false;

  tl.add('snap-0')
    .fromTo(
      animState,
      {
        frame: 0,
      },
      {
        frame: framesCount - 1,
        snap: 'frame',
        ease: 'none',
        onUpdate: render,
        duration: 3,
        ease: 'none',
      },
    )
    .from('.tt-dots', {
      autoAlpha: 0,
      duration: 0.5,
    })

    .from('.tt-dot__dot', {
      scale: 0,
      stagger: 0.2,
      duration: 1,
      // ease: 'elastic.out(1,0.3)',
      onComplete: () => {
        if (!dotPopupShown) {
          document.querySelector('.tt-dot:first-of-type').classList.add('is-active', 'dot-tap');
          dotPopupShown = true;
        }
      },
    })

    .add('snap-1')
    .to({}, { duration: 1 })
    .add('snap-final');

  const ST = ScrollTrigger.create({
    animation: tl,
    trigger: '.tt-frames__trigger',
    start: window.innerWidth < 768 ? 'top-=84px top' : 'top-=90px top',
    end: '+=' + window.innerHeight * 2,
    scrub: 0.05,
    pin: true,
    snap: {
      snapTo: 'labelsDirectional',
      inertia: true,
    },
  });

  // const pinST = ScrollTrigger.create({
  //   trigger: '.tt-frames__trigger',
  //   start: 'top-=90px top',
  //   end: '+=' + window.innerHeight * 1.5,
  //   pin: true,
  // });

  // const dotsTl = gsap.timeline({ paused: true });

  // dotsTl.from('.tt-dot__dot', {
  //   scale: 0,
  //   stagger: 0.15,
  //   duration: 2.5,
  //   ease: 'elastic.out(1,0.3)',
  // });

  // const dotsST = ScrollTrigger.create({
  //   trigger: '.tt-frames__trigger',
  //   start: `top+=90px top`,
  //   animation: dotsTl,
  //   markers: true,
  // });

  document.querySelectorAll('.tt-dot__dot').forEach((el) => {
    el.addEventListener('click', (e) => {
      e.stopPropagation();

      const dotEl = el.closest('.tt-dot');
      dotEl.classList.toggle('is-active');

      // const toggle = !dotEl.classList.contains('.is-active');

      document.querySelectorAll('.tt-dot').forEach((_el) => {
        if (dotEl !== _el) {
          _el.classList.remove('is-active');
        }
      });

      // dotEl.classList.toggle('is-active', toggle);
    });
  });

  document.querySelectorAll('.tt-dot__popup').forEach((el) => {
    el.addEventListener('click', (e) => {
      e.stopPropagation();
    });
  });

  /**
   * Click Mapping for dots
   */
  document.querySelector('.tt-dots').addEventListener('click', function (e) {
    document.querySelectorAll('.tt-dot').forEach((el) => {
      el.classList.remove('is-active');
    });

    return;

    const rect = e.target.getBoundingClientRect();
    let x = e.clientX - rect.left;
    let y = e.clientY - rect.top;

    y = (y / rect.height) * 100;
    y = y.toFixed(3);

    x = (x / rect.width) * 100;
    x = x.toFixed(3);

    prompt('Copy the value given', `${x}, ${y}`);
  });
});
